export default {
  FAILED: 'failed',
  LOADING: 'loading',
  SUCCEEDED: 'succeeded',
  WAITING: 'waiting',
};
